export default __webpack_public_path__ + "static/media/guide0306_m.52858445.jpg";